import styled from 'styled-components'
import { mixins } from "../css-variables"

const ContentDivider = styled.hr`
    ${mixins.content_divider}
`
export default ContentDivider